import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Modal } from 'react-bootstrap'

import base from 'Styles/base.css'
import style from './style.css'

import closeIcon from 'Assets/x-icon-gray.svg'

export default class EditTargetScoreModal extends Component {
  constructor (props) {
    super(props)

    this.onSetTargetScore = this.onSetTargetScore.bind(this)
    this.onTargetScoreChange = this.onTargetScoreChange.bind(this)
    this.onProceed = this.onProceed.bind(this)

    this.state = {
      scoreTarget: parseInt(this.props.scoreTarget, 10),
      studentActivity: props.studentActivity,
      badTargetScore: false
    }
  }

  onProceed () {
    this.setState({
      studentActivity: false,
      badTargetScore: false
    })
  }

  onTargetScoreChange (event) {
    // numbers only
    let scoreTarget = event.target.value.replace(/\D/g, '')
    scoreTarget = scoreTarget.length > 4
      ? scoreTarget.substr(0, 4)
      : scoreTarget
    // remove any leading zeros
    scoreTarget = scoreTarget.length > 0
      ? parseInt(scoreTarget, 10)
      : scoreTarget
    this.setState({ scoreTarget })
  }

  onSetTargetScore () {
    const scoreTarget = parseInt(this.state.scoreTarget, 10)
    if (scoreTarget > 0) {
      this.props.onSetTargetScore(scoreTarget)
    }
  }

  renderEditTargetModal () {
    const divInline = {
      display: 'inline-block'
    }
    return (
      <Modal show={true} className={style.wrapper} data-test-id="editTargetScoreModal">
        <div className={style.containerModal}>
          <Modal.Header className={style.targetHeader}>
            <button
              data-test-id="closeEditTargetScore"
              aria-label="Close Edit Target Score"
              className={classnames(style.closeEditTarget, style.hideModal)}
              onClick={this.props.onCancelEditTargetScore}
              tabIndex="0"
            >
              <object
                data={closeIcon} type="image/svg+xml"
                className={base.svgIcon}
                tabIndex="-1"
              />
            </button>
            <Modal.Title className={style.title}>
              Edit Target Score
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={style.text} tabIndex="0">
            Edit this value to adjust how many questions a student must answer in order to
            receive a grade of 100% for the activity.

            <h3 className={style.targetScore}>
              Target score:
              <input
                className={style.targetScoreInput}
                value={this.state.scoreTarget}
                onChange={this.onTargetScoreChange.bind(this)}
                tabIndex="0"
                data-test-id="editTargetScoreScore"
              />
              points
            </h3>
            The default target score is 150 times the number of topics in the activity,
            which ensures that every student answers at least 5 questions for each topic
            (even if he/she gets every question right without hints or incorrect guesses).
          </Modal.Body>
          <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
            <div style={divInline}>
              <div className={style.buttonContainer}>
                <button
                  className={classnames('btn-cdl-main', style.changeButton)}
                  onClick={(event) => (this.state.scoreTarget / this.props.numberOfTopics) < 50 ||
                  (this.state.scoreTarget / this.props.numberOfTopics) > 300
                    ? this.setState({ badTargetScore: true })
                    : this.props.onSetTargetScore(this.state.scoreTarget)}
                  data-test-id="editTargetScoreChangeScoreBtn"
                >
                Change Target Score
                </button>
              </div>
            </div>
            <div style={divInline}>
              <div className={style.buttonContainer}>
                <button
                  className={classnames('btn-cdl-secondary', style.cancelButton)}
                  onClick={this.props.onCancelEditTargetScore}
                  data-test-id="editTargetScoreCancelBtn"
                >
                Cancel
                </button>
              </div>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    )
  }

  renderActivityWarningModal () {
    const divInline = {
      display: 'inline-block'
    }
    return (
      <Modal show={true}>
        <div className={style.containerModal}>
          <Modal.Header className={style.targetScoreHeader}>
            <button
              data-test-id="closeEditTargetScore"
              aria-label="Close Edit Target Score"
              className={classnames(style.closeEditTarget, style.hideModal)}
              onClick={this.props.onCancelEditTargetScore}
              tabIndex="0"
            >
              <object
                data={closeIcon} type="image/svg+xml"
                className={base.svgIcon}
                tabIndex="-1"
              />
            </button>
            <Modal.Title className={style.title}>
              Students have begun this activity!
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={style.text} tabIndex="0">
            {`Changing the target score may affect completion status for some students,
            invalidate target score timestamps, and they will need to revisit the
            activity for their grades to update.`}
            <span className={style.question}>
              This affects the entire class. Are you sure you want to do this?
            </span>
          </Modal.Body>
          <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
            <div style={divInline}>
              <div className={style.buttonContainer}>
                <button
                  className={classnames('btn-cdl-main', style.proceedButton)}
                  onClick={this.onProceed}
                >
                  Proceed
                </button>
              </div>
            </div>
            <div style={divInline}>
              <div className={style.buttonContainer}>
                <button
                  className={classnames('btn-cdl-secondary', style.cancelButton)}
                  onClick={this.props.onCancelEditTargetScore}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    )
  }

  renderScoreWarningModal () {
    const lowMessageHeader = 'Your activity requires very few questions to be answered.'
    const lowMessageFooter = 'We recommend a target score of no less than 50 points per topic to ensure' +
    ' that students have to answer at least two questions per topic.'
    const lowMessageButton = 'A very short activity is OK'
    const highMessageHeader = 'Your students may see a lot of duplicate questions.'
    const highMessageFooter = 'We recommend a target score of no more than 300 points per topic to ensure' +
    ' that students don\'t keep seeing the same questions.'
    const highMessageButton = 'Duplicate questions are OK'
    const pointsPerTopic = Math.round((this.state.scoreTarget / this.props.numberOfTopics) * 10) / 10
    const divInline = {
      display: 'inline-block'
    }
    return (
      <Modal show={true}>
        <div className={style.containerModal}>
          <Modal.Header className={style.topicsHeader}>
            <Modal.Title className={style.title}>
              Target Score Alert
              <button
                data-test-id="closeEditTargetScore"
                aria-label="Close Edit Target Score"
                className={classnames(style.closeEditTarget, style.hideModal)}
                onClick={this.props.onCancelEditTargetScore}
                tabIndex="0"
              >
                <object
                  data={closeIcon} type="image/svg+xml"
                  className={base.svgIcon}
                  tabIndex="-1"
                />
              </button>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={style.text} tabIndex="0">
            {pointsPerTopic < 50 ? lowMessageHeader : highMessageHeader}
            <table className={style.feedbackSection}>
              <tbody>
                <tr className={style.targetTableRow}>
                  <td className={style.targetTableLeftLabel}>Target score entered</td>
                  <td className={style.targetTableMiddleLabel}>:</td>
                  <td className={style.feedbackValue}>{this.state.scoreTarget} pts</td>
                </tr>
                <tr className={style.targetTableRow}>
                  <td className={style.targetTableLeftLabel}>Topics covered</td>
                  <td className={style.targetTableMiddleLabel}>:</td>
                  <td className={style.feedbackValue}>{this.props.numberOfTopics}</td>
                </tr>
                <tr className={style.targetTableRow}>
                  <td className={style.targetTableLeftLabel}>Points per topic</td>
                  <td className={style.targetTableMiddleLabel}>:</td>
                  <td className={style.feedbackValue}>{pointsPerTopic} pts</td>
                </tr>
              </tbody>
            </table>
            {pointsPerTopic < 50 ? lowMessageFooter : highMessageFooter}
          </Modal.Body>
          <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
            <div style={divInline}>
              <div className={style.buttonContainer}>
                <button
                  className={classnames('btn-cdl-main', style.proceedOkay)}
                  onClick={(event) => this.props.onSetTargetScore(this.state.scoreTarget)}
                >
                  {pointsPerTopic < 50 ? lowMessageButton : highMessageButton}
                </button>
              </div>
            </div>
            <div style={divInline}>
              <div className={style.buttonContainer}>
                <button
                  className={classnames('btn-cdl-secondary', style.cancelButton)}
                  onClick={this.onProceed}
                >
                  Edit Target Score
                </button>
              </div>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    )
  }

  render () {
    if (this.state.badTargetScore) {
      return this.renderScoreWarningModal()
    }
    return this.state.studentActivity && !this.props.hideWarningForSampleStudents
      ? this.renderActivityWarningModal()
      : this.renderEditTargetModal()
  }
}

EditTargetScoreModal.propTypes = {
  scoreTarget: PropTypes.number.isRequired,
  onSetTargetScore: PropTypes.func.isRequired,
  onCancelEditTargetScore: PropTypes.func.isRequired,
  studentActivity: PropTypes.bool.isRequired,
  numberOfTopics: PropTypes.number.isRequired,
  hideWarningForSampleStudents: PropTypes.bool.isRequired
}
